/**
 * TR Homepage V1 Carousel Controller (tr-homepage-v1.js)
 * Smoothly scrolls carousel tracks with desktop arrow buttons.
 */
(function () {
  'use strict';

  function syncHeaderHeight() {
    const headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('header');
    if (headerWrapper) {
      const h = Math.round(headerWrapper.getBoundingClientRect().height);
      if (h > 0) {
        document.documentElement.style.setProperty('--header-height', h + 'px');
      }
    }
  }

  function initCarousels() {
    document.querySelectorAll('.tr-carousel-arrow').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-target');
        const track = document.getElementById(targetId);
        if (!track) return;

        const isPrev = btn.classList.contains('tr-carousel-arrow--prev');
        const scrollAmount = track.clientWidth * 0.75;
        track.scrollBy({
          left: isPrev ? -scrollAmount : scrollAmount,
          behavior: 'smooth'
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncHeaderHeight();
      initCarousels();
    });
  } else {
    syncHeaderHeight();
    initCarousels();
  }
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
})();
